export const SOCIAL = [
	{
		id: 1,
		name: 'Twitter',
		url: 'https://x.com/atlasrndm',
		iconDark: '/twitter-dark.png',
		iconLight: '/twitter-light.png',
	},
	{
		id: 2,
		name: 'Discord',
		url: 'http://discord.gg/rndmio',
		iconDark: '/discord-dark.png',
		iconLight: '/discord-light.png',
	},
	{
		id: 3,
		name: 'Doc',
		url: 'https://docs-atlas.rndm.io',
		iconDark: '/doc-dark.png',
		iconLight: '/doc-light.png',
	},
	/*{
		id: 4,
		name: 'Audit Report',
		url: 'http://movebit.xyz/reports/20251120-RNDM-Final-Audit-Report.pdf',
		iconDark: '',
		logo: '/mobit.png',
	},*/
];
